import instance from '../instance';

export const getAllStaff = async (query, sort) => {
  try {
    const res = await instance.get('/staff', {
      params: { query, sort },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getPaginated = async (page, perPage, search, sort) => {
  try {
    const res = await instance.get('/staff/paginated', {
      params: { page, perPage, search, sort },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const create = async (data) => {
  try {
    const res = await instance.post('/staff', data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const edit = async (data) => {
  try {
    const res = await instance.put('/staff', data);
    return res.data;
  } catch (error) {
    throw error;
  }
};
